import { useTranslation } from 'react-i18next';

import { Button } from '@ctct/payflow-ui';

import type { LoadedStripePaymentMethodsWidgetProps } from './usePaymentMethodsWidget';
import { CreditCardSavedPaymentMethod } from '../../components/CreditCardSavedPaymentMethod';
import { PayPalLogo } from '../../components/PayPalLogo';

const StripeSavedPaymentMethodDisplay = ({ data }: LoadedStripePaymentMethodsWidgetProps) => {
  const { t } = useTranslation();
  const paymentMethodType = data.getPaymentMethodType();

  switch (paymentMethodType) {
    case 'card':
      return (
        <CreditCardSavedPaymentMethod
          logoName={data.getCreditCardLogoName()}
          creditCardBrandDisplayName={data.getCreditCardName()}
          creditCardType={data.getCreditCardType()}
          formattedCardNumber={data.getCreditCardNumberFormatted()}
          expirationDate={data.getCreditCardExpirationDate()}
        />
      );
    case 'custom':
      return <PayPalLogo />;
    case 'acss_debit':
      return <div>{t('payment-methods.preauthorized_debit')}</div>;
    case 'us_bank_account':
      return <div>{t('payment-methods.us_bank_account')}</div>;
    case 'amazon_pay':
      return <div>{t('payment-methods.amazon_pay')}</div>;
    case 'google_pay':
      return <div>{t('payment-methods.google_pay')}</div>;
    case 'apple_pay':
      return <div>{t('payment-methods.apple_pay')}</div>;
    default:
      // Should never get here, but let's display a default message
      return <div>{t('payment-methods.unknown_payment_method')}</div>;
  }
};

export const StripeSavedPaymentMethod = (props: LoadedStripePaymentMethodsWidgetProps) => {
  const { t } = useTranslation();
  const { handlers } = props;
  const editButton = (
    <Button
      onClick={handlers.onEditExistingPaymentMethod}
      size="medium"
      variant="text"
      title={t('payment-methods.change_payment_method')}
    >
      {t('payment-methods.edit')}
    </Button>
  );

  return (
    <div className="stripe-saved-payment-method">
      <StripeSavedPaymentMethodDisplay {...props} />
      {editButton}
    </div>
  );
};
